import { QueryBuilder } from '../../services/query-builder.service';
import { TicketService } from '../../services/tickets/ticket.service';

export const initialise = () => {
  const getCustomer = ($stateParams, customerService, $q) => {
    if ($stateParams.customerId === 'anonymous') {
      const deferred = $q.defer();

      deferred.resolve({
      });

      return deferred.promise;
    }

    return customerService.getCustomer($stateParams.customerId);
  };
  getCustomer.$inject = ['$stateParams', 'customerService', '$q'];

  const getCustomerSchemas = (customerSchemaService, userService, queryBuilder: QueryBuilder) => {
    return customerSchemaService.getList(1, 15, queryBuilder.schemeIs(userService.selectedScheme.id).getParam());
  };
  getCustomerSchemas.$inject = ['customerSchemaService', 'userService', 'QueryBuilder'];

  const getPurses = ($stateParams, customerService, queryBuilder: QueryBuilder) => {
    return customerService.getPurses(undefined, undefined, queryBuilder.customerLinkIs($stateParams.customerId).getParam());
  };
  getPurses.$inject = ['$stateParams', 'customerService', 'QueryBuilder'];

  const getTickets = ($stateParams, customerService, queryBuilder: QueryBuilder, ticketService: TicketService, $location: ng.ILocationService) => {
    if ($stateParams.ticketId === 'anonymous') {

      let cardId = '';

      if ($location.search().hasOwnProperty('cardNumber')) {
        cardId = $location.search()['cardNumber'];
      }

      const query = queryBuilder.newParam().fieldIs('usageToken.ISRN', cardId).getParam();
      return ticketService.getTickets(query);
    }

    return customerService.getTickets(queryBuilder.customerLinkIs($stateParams.customerId).getParam());
  };

  getTickets.$inject = ['$stateParams', 'customerService', 'QueryBuilder', 'ticketService', '$location'];

  const getEntitlements = ($stateParams, customerService, queryBuilder: QueryBuilder) => {
    return customerService.getEntitlements(queryBuilder.customerLinkIs($stateParams.customerId).getParam());
  };
  getEntitlements.$inject = ['$stateParams', 'customerService', 'QueryBuilder'];

  const getChargeAccounts = ($stateParams, chargeAccountService, queryBuilder: QueryBuilder) => {
    return chargeAccountService.getChargeAccounts(undefined, undefined, queryBuilder.customerLinkIs($stateParams.customerId).getParam());
  };
  getChargeAccounts.$inject = ['$stateParams', 'chargeAccountService', 'QueryBuilder'];

  const getPayment = ($stateParams, customerService) => {
    return customerService.getPayments(undefined, $stateParams.paymentId);
  };
  getPayment.$inject = ['$stateParams', 'customerService'];

  const getJourneys = ($stateParams, journeyService) => {
    return journeyService.getList(undefined, undefined, 'paymentLink.link=/payments/' + $stateParams.paymentId);
  };
  getJourneys.$inject = ['$stateParams', 'journeyService'];

  const getPhoto = (photoService, $stateParams, $window, $q) => {
    return new $q((resolve, reject) => {
      if ($stateParams.customer.currentPhotoId) {
        photoService.getCustomerPhoto($stateParams.customer.id, $stateParams.customer.currentPhotoId).then((response) => {
          const blob = new Blob([response]);

          try {
            resolve(($window.URL || (<any>$window).webkitURL).createObjectURL(blob));
          } catch (err) {
            reject(err);
          }
        });
      } else {
        resolve();
      }
    });
  };
  getPhoto.$inject = ['photoService', '$stateParams', '$window', '$q'];

  angular.module('actora.customers').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');
    $stateProvider.state('customers', {
      url: '/customers',
      templateUrl: 'app/angularJS/features/customers/list/customers-list.html',
      controller: 'CustomersListController',
      controllerAs: 'vm',
      parent: 'common'
    }).state('customer', {
      url: '/customer/:customerId',
      template: '<div ui-view></div>',
      controller: 'CustomerPageController',
      controllerAs: 'vm',
      resolve: {
        customer: getCustomer
      },
      parent: 'common'
    }).state('customer.details', {
      url: '/detail?cardNumber',
      templateUrl: 'app/angularJS/features/customers/detail/customer-detail.html',
      controller: 'CustomerDetailController',
      controllerAs: 'vm',
      resolve: {
        customer: getCustomer
      },
      data: {
        selectedTab: 1
      }
    }).state('customer.smartmedia', {
      url: '/smartmedia',
      template: '<div ui-view></div>',
      abstract: true,
      data: {
        selectedTab: 2
      }
    }).state('customer.smartmedia.list', {
      url: '/activeCards?cardNumber',
      templateUrl: 'app/angularJS/features/customers/smart-media/customer-smart-media.html',
      controller: 'CustomerSmartMediaListController',
      controllerAs: 'vm'
    }).state('customer.smartmedia.addCard', {
      url: '/addCard',
      templateUrl: 'app/angularJS/features/customers/smart-media/add-card/customer-add-card.html',
      controller: 'SmartMediaAddCardController',
      controllerAs: 'vm'
    }).state('customer.tickets', {
      url: '/tickets?cardNumber',
      templateUrl: 'app/angularJS/features/customers/tickets/customer-tickets.html',
      controller: 'CustomerTicketsController',
      controllerAs: 'vm',
      data: {
        selectedTab: 4
      }
    }).state('customer.ticketdetails', {
      url: '/ticketDetails?ticketId',
      templateUrl: 'app/angularJS/features/customers/ticket-details/ticket-details.html',
      controller: 'TicketDetailsController',
      controllerAs: 'vm',
      data: {
        selectedTab: 4
      }
    }).state('customer.purses', {
      url: '/purses',
      templateUrl: 'app/angularJS/features/customers/purses/customer-purses.html',
      controller: 'CustomerPursesController',
      controllerAs: 'vm',
      params: {
        customerId: undefined
      },
      data: {
        selectedTab: 5
      },
      resolve: {
        purses: getPurses
      }
    }).state('customer.entitlements', {
      url: '/entitlements',
      templateUrl: 'app/angularJS/features/customers/entitlements/customer-entitlements.html',
      controller: 'CustomerEntitlementsController',
      controllerAs: 'vm',
      params: {
        customerId: undefined
      },
      data: {
        selectedTab: 6
      }
    }).state('customer.payments', {
      url: '/payments',
      template: '<div ui-view></div>',
      abstract: true,
      data: {
        selectedTab: 7
      }
    }).state('customer.payments.list', {
      url: '/list',
      templateUrl: 'app/angularJS/features/customers/payments/list/payment-list.html',
      controller: 'PaymentListController',
      controllerAs: 'vm'
    }).state('customer.payments.ticketHistory', {
      url: '/ticketHistory/:paymentHistoryId',
      templateUrl: 'app/angularJS/features/customers/payments/ticket/ticket-history.html',
      controller: 'TicketHistoryController',
      controllerAs: 'vm'
    }).state('customer.chargeAccount', {
      url: '/chargeAccount',
      template: '<div ui-view></div>',
      abstract: true,
      data: {
        selectedTab: 8
      }
    }).state('customer.chargeAccount.list', {
      url: '/chargeAccountList',
      templateUrl: 'app/angularJS/features/customers/charge-account/charge-account-list.html',
      controller: 'ChargeAccountListController',
      controllerAs: 'vm',
      resolve: {
        activeChargeAccounts: getChargeAccounts
      }
    }).state('customer.chargeAccount.add', {
      url: '/chargeAccountAdd',
      templateUrl: 'app/angularJS/features/customers/charge-account/customer-charge-account.html',
      controller: 'CustomerChargeAccountController',
      controllerAs: 'vm'
    }).state('customer.payment_detail', {
      url: '/payments/:paymentId',
      templateUrl: 'app/angularJS/features/customers/payments/detail/payment-detail.html',
      controller: 'PaymentDetailController',
      controllerAs: 'vm',
      resolve: {
        payment: getPayment,
        activities: getJourneys
      },
      params: {
        paymentId: undefined
      }
    }).state('customers-create', {
      url: '/customers/create',
      templateUrl: 'app/angularJS/features/customers/create/customers_create.html',
      controller: 'CustomersCreateController',
      controllerAs: 'vm',
      resolve: {
        customerSchemas: getCustomerSchemas
      },
      parent: 'common'
    }).state('customer.edit', {
      url: '/edit',
      templateUrl: 'app/angularJS/features/customers/edit/customer-edit.html',
      controller: 'CustomerEditController',
      controllerAs: 'vm',
      params: {
        customerId: undefined,
        customer: undefined
      },
      resolve: {
        customer: getCustomer,
        customerImage: getPhoto
      }
    });
    $urlRouterProvider.otherwise('/');
  }]);
};
